module.exports = __webpack_public_path__ + "img/cdz.ff745d94.png";